module.exports = __webpack_public_path__ + "img/search.01c408f6.svg";